/** @jsx jsx */
import { Container } from "@eworkit/iris";
import { MessageCenter } from "@eworkit/messenger";
import { FC } from "react";
import { jsx } from "theme-ui";

import { useFeatureFlags } from "@/components/FeatureFlags";
import { FEATURE_FLAG } from "@/data/feature-flags";
import { Error4XX } from "@/views/Errors";

interface MessageCenterPageProps {}

export const MessageCenterPage: FC<MessageCenterPageProps> = () => {
  const { isFeatureEnabled } = useFeatureFlags();

  return isFeatureEnabled(FEATURE_FLAG.MESSAGE_CENTER) ? (
    <Container sx={{ height: "calc(100vh - 73px)" }}>
      <MessageCenter />
    </Container>
  ) : (
    <Error4XX />
  );
};
